import { FOLDER_MODULES } from "@/app/common/model/constants";
import angular, {IPromise} from "angular";
import _ from "lodash";
import {DocumentFolder, FolderTypeCodes} from "@common/model/documentFolder";
import {PermissionsEnum, TargetEnum} from "ecv/common/permissions";
import {CacheService} from "@common/service/cache.service";
import {ICachingService} from "@common/service/caching.service";
import {IUtilityService} from "@common/service/util.service";
import {JavaApiAdapterService} from "@common/apiadapter/javaapi.service";
import {CommonService} from "@common/common.service";
import {IFeedService} from "@common/service/feed.service";
import {IAppRootScopeService} from "@app/app.definition";
import {PopUpService} from "@common/popup/popup.service";
import {PaymentService} from "@common/service/payment.service";
import { PermissionService } from "ecv/common/permissions";
import {Subject} from "@common/model/subject";
import {SubjectService} from "@common/service/subject.service";


    export interface IDocumentFolderService {
        getBrdcrmbFromFolderId(folderId: any, DISCUSSION: string): ng.IPromise<any>;
        connect(id: any): void;
        organize(id: any): void;
        fetchFolderById(folderId: any): any;
        folderFilterList: any;
        init: Function;
        updateFolderUpdationDate:Function;
        reset: Function;
        folderOperation: Function;
    }
    export class DocumentFolderService implements IDocumentFolderService {
        folders: any;
        module: string;
        docs: any;
        pageSize: number = 50;
        ItemTypeEnum = {
            FOLDER: 1,
            DOCUMENT_OR_DISCUSSION: 2
        };
        folderSort = {};
        docSort = {};
        viewPortSize;
       gridItemSize;
       folderFilterList;

        isActionAllowed = (status: number, factor: any): boolean => {
            return (status & factor) == factor;
        }

        isTeamMember = (isAllowed, item) => {
            if (item.folderType.includes("SUBJECT")) {
                return item.subject && item.subject.isActiveMember && isAllowed
            } else {
                return isAllowed
            }
        }

        getDocumentType = (module) => {
            //For RL we need to pass document type as document
            return module == FOLDER_MODULES.RESOURCE_LIBRARY ? FOLDER_MODULES.DOCUMENT : module;
        }

        fetchSubjectForFolder = (folders) => {
            var deferred = this.$q.defer();
            let withsubject = folders.filter(i => i.subjectId);
            let subjIds = _.map(withsubject, 'subjectId');
            let subjArr;
            if (subjIds.length > 0) {
                this.$sub.getSubjectListByIds(_.uniq(subjIds)).then(
                    (subjects: Subject[]) => {
                        subjArr = Object.keys(subjects).map(key => subjects[key]);
                        folders.forEach(rd => {
                            if (rd.subjectId) rd.subject = subjArr.find(s => s.subjectId == rd.subjectId);
                        });
                        deferred.resolve(folders);
                    })

            } else {
                deferred.resolve(folders);
            }
            return deferred.promise;
        }

        fetchFolderWithSubject = (folderId, params) => {
            return this.fetchFoldersFrmBcknd(folderId, params).then((data : any) => {
                return this.fetchSubjectForFolder(data.folders).then((folders) => {
                    data.folders = folders;
                    return data
                })
            })
        }

        fetchFoldersFrmBcknd = (folderId, params) => {
            var deferred = this.$q.defer();
            let currentUser = this.$_cache.getUser();
            if (this.module == FOLDER_MODULES.DOCUMENT || this.module == FOLDER_MODULES.RESOURCE_LIBRARY) {
                let folderType;
                if(folderId == 0){
                    folderType = FolderTypeCodes.ROOT;
                } else if(this.folders && this.folders[this.module]) {
                    let fldr = this.folders[this.module].find((f) => f.id == folderId);
                    folderType = fldr? fldr.folderType : null;
                }
                !!folderType && (params['folderType'] = folderType);
                if(this.module == FOLDER_MODULES.RESOURCE_LIBRARY){
                    params['RLFoldersOnly'] = true;
                    this.PermissionService.getPermissionsForTarget(TargetEnum.RESOURCE_LIBRARY_FOLDER, [currentUser.partyId]).then(data => {
                        if (Array.isArray(data) && data.length > 0) {
                            params['rsLibUserListPerm'] = data[0][TargetEnum.RESOURCE_LIBRARY_FOLDER][PermissionsEnum.LIST];
                        }
                        let subj = this.$_cache.getCurrentSubject();
                        if (subj) {
                            this.PermissionService.getPermissionsForTarget(TargetEnum.RESOURCE_LIBRARY_FOLDER, [subj.teamPartyId]).then(perms => {
                                if (Array.isArray(perms) && perms.length > 0) {
                                    params['rsLibSubjListPerm'] = perms[0][TargetEnum.RESOURCE_LIBRARY_FOLDER][PermissionsEnum.LIST];
                                }
                                this.$_api.fetchFolders(currentUser.id, folderId, params).then((fldrs) => {
                                    deferred.resolve(fldrs);
                                });
                            });
                        } else {
                            this.$_api.fetchFolders(currentUser.id, folderId, params).then((fldrs) => {
                                deferred.resolve(fldrs);
                            });
                        }
                    });
                } else {
                    this.$_api.fetchFolders(currentUser.id, folderId, params).then((fldrs) => {
                        deferred.resolve(fldrs);
                    });
                }
            } else {
                this.$_api.fetchFolders(currentUser.id, folderId, params).then((fldrs) => {
                    deferred.resolve(fldrs);
                });
            }
            return deferred.promise;
        }

        fetchChildFolders = (folderId, folderSortedBy?, subjectId?,startIndex=0, endIndex=10) => {
            var deferred = this.$q.defer();
            var folderArray = this.folders[this.module];
            if(!!folderArray){
                let children = [],childrenLen = 0, totalChldrn = -1;
                let crntFldr  = folderArray.find((f) => f.id == folderId);
                if(folderId != 0 && (!crntFldr || !!crntFldr['reloadChildren'] || crntFldr['childCount'] == undefined)){
                    this.folders[this.module] = folderArray.filter((f) => f.parentId != folderId);
                } else {
                    totalChldrn = !!crntFldr? crntFldr['childCount'] : (folderId == 0? 1 : -1);
                    children = folderArray.filter((f) => f.parentId == folderId && (!subjectId || !f.subjectId || f.subjectId == subjectId));
                    childrenLen = children.length;
                }

                if(childrenLen  >= endIndex || childrenLen == totalChldrn){
                    deferred.resolve(children.slice(startIndex, endIndex));
                } else {
                    folderArray = this.folders[this.module];
                    let prnt = folderArray.find(f => f.id == folderId);
                    let pageNo = Math.floor(childrenLen/this.pageSize);
                    let params = {
                        documentType: this.getDocumentType(this.module),
                        pageSize: this.pageSize,
                        pageNo: pageNo
                    };
                    if(!!folderSortedBy){
                        params['sortBy'] = folderSortedBy['sortBy'];
                        params['sortOrder'] = folderSortedBy['sortOrder'];
                    }
                    if(this.module == FOLDER_MODULES.DOCUMENT && !!subjectId && !!prnt && _.includes([FolderTypeCodes.ENTERPRISE_TEAMS, FolderTypeCodes.SYSTEM_SUBJECT, FolderTypeCodes.SUBJECT], prnt.folderType)){
                        params['subjectId'] = subjectId;
                    }
                    this.fetchFoldersFrmBcknd(folderId, params).then((data) => {
                        if(!!folderId && !!prnt){
                            prnt['childCount'] = data['totalElements'];
                            prnt['reloadChildren'] = false;
                        }
                        this.fetchSubjectForFolder(data['folders']).then((fldrs : [])=>{
                            fldrs.forEach((f : any) => {
                                f.type = this.ItemTypeEnum.FOLDER;
                                if(!folderArray.find(fldr => fldr.id == f.id)){
                                    this.folders[this.module].push(f);
                                }
                            });
                            this.$timeout(()=>{
                                children = children.concat(fldrs);
                                deferred.resolve(children.slice(startIndex, endIndex));
                            }, 100);
                        })

                    });
                }
            }

            return deferred.promise;
        }

        fetchFolderHierarchy = (folderId ,module?:string,subjectId?:number) => {
            var deferred = this.$q.defer();
            let params = {
                fetch: 'hierarchy',
                documentType: module ? this.getDocumentType(module) :""
            };
            if(!!subjectId){
                params['subjectId'] = subjectId;
            }
            this.fetchFolderWithSubject(folderId, params).then((data) => {
                deferred.resolve(data['folders']);
            });
            return deferred.promise;
        }
        init = (type?: string, initialCall?) => {
            let deferred = this.$q.defer();
            if(!!initialCall) {
                this.module = type;
            }
            if(!this.folders){
                this.folders = {};
                this.folders[this.module] = [];
            } else if(!this.folders[this.module]) {
                this.folders[this.module] = [];
            }
            this.fetchChildFolders(0).then(() => {
                let fId = this.$state.params.folderId;
                let fldrArray = this.folders[this.module];
                //If user is inside a folder and refreshes the page, fetch the folder hierarchy to
                // maintain the breadcrumb
                if(!!fId && !fldrArray.find(f => f.id == fId)){
                    this.fetchFolderHierarchy(fId,this.module).then((fldrs : []) => {
                        fldrs.forEach((f : any) => {
                            f.type = this.ItemTypeEnum.FOLDER;
                            if(!fldrArray.find(fldr => fldr.id == f.id)){
                                this.folders[this.module].push(f);
                            }
                        });
                        deferred.resolve('success');
                    });
                } else {
                    deferred.resolve('success');
                }

            });
            return deferred.promise;
        }

        /**
         * Reset the childCount of the folder so that child folders can be fetched from backend
         * @param obj Params to find the folder
         */
        resetChildren = (obj) => {
            let keys = Object.keys(obj);

            let teamsFldr = this.folders[this.module].find(f => {
                let resp = true;
                keys.forEach((k) =>{
                    if(f[k] != obj[k]){
                        resp = false;
                    }
                });
                return resp;
            });
            if(!!teamsFldr){
                teamsFldr['reloadChildren'] = true;
            }
        }

        /**
         * This is called when sort order is changed so that sorted list can be fetched from backend
         * @param folderId  Id of the current folder
         * @returns {IPromise<T>}
         */
        resetFolders = (folderId : number) : IPromise<any> => {
            let deferred = this.$q.defer();
            this.folders[this.module] = [];
            this.fetchFolderHierarchy(folderId,this.module).then((fldrs : []) => {
                fldrs.forEach((f : any) => {
                    f.type = this.ItemTypeEnum.FOLDER;
                });
                this.folders[this.module] = this.folders[this.module].concat(fldrs);
                deferred.resolve('success');
            });

            return deferred.promise;
        }
        reset = () => {
            this.folderFilterList = null;
            this.folders = null;
            this.docs = null;
        }

        /**
         * Gets the subject folder to display the short cut for the selected subject
         * @param subjectId
         * @returns {IPromise<T>}
         */
        fetchSubjectFolder = (subjectId : number):IPromise<any> => {
            let deferred = this.$q.defer();
            let fldrArray = this.folders[this.module];
            let subjFolder = fldrArray.find((f) => f.subjectId == subjectId && f.folderType == FolderTypeCodes.SYSTEM_SUBJECT);
            if(!!subjFolder) {
                deferred.resolve(subjFolder);
            } else {
                this.fetchFolderHierarchy(0,this.module,subjectId).then((fldrs : [] ) => {
                    let resp;
                    fldrs.forEach((f : any) => {
                        f.type = this.ItemTypeEnum.FOLDER;
                        if(!fldrArray.find(fldr => fldr.id == f.id)){
                            this.folders[this.module].push(f);
                        }
                        if(f.subjectId == subjectId){
                            resp = f;
                        }
                    });
                    deferred.resolve(resp);
                });
            }
            return deferred.promise;
        }

        fetchRootFolder = () => {
            //For RL the root folder is the resource library folder
            if(this.module == FOLDER_MODULES.RESOURCE_LIBRARY){
                return this.folders[this.module].find(f => f.folderType == FolderTypeCodes.RESOURCE_LIBRARY);
            }
            return this.folders[this.module].find(f => f.folderType == FolderTypeCodes.ROOT);
        }

        fetchRootFolderByType = (module) => {
            let deferred = this.$q.defer();
            let params = {
                documentType: this.getDocumentType(module),
            };
            this.fetchFolderWithSubject(0, params).then((data) => {
                //For RL the root folder is the resource library folder
                if(module == FOLDER_MODULES.RESOURCE_LIBRARY){
                    deferred.resolve(data['folders'].find(f => f.folderType == FolderTypeCodes.RESOURCE_LIBRARY));
                } else {
                    deferred.resolve(data['folders'].find(f => f.folderType == FolderTypeCodes.ROOT));
                }
            });
            return deferred.promise;
        }

        fetchSharedWithMeFolderId = () : number => {
            let swFldrId : number;
            let swFldr = this.folders[this.module].find((f) => {return f.folderType == FolderTypeCodes.SYSTEM && f.name == 'Shared With Me'});
            if(!!swFldr){
                swFldrId = swFldr.id;
            }
            return swFldrId;
        }

        fetchFaxedToMeFolder = () => {
            return this.folders[FOLDER_MODULES.DOCUMENT].find((f) => {return f.folderType == FolderTypeCodes.SYSTEM && f.name == 'Faxed To Me'});
        }

        fetchFolderById = (folderId : number | String) => {
            if(folderId == ""){
                folderId = this.fetchRootFolder().id;
            }
            return this.folders[this.module].find((f) => { return f.id == folderId });
        }

        fetchFolderByFolderType = (type: FolderTypeCodes) => {
            return this.folders[this.module].find(f => f.folderType == type);
        }

        fetchChildDocs = (folderId : number, subjectId : number, sortProp = this.docSort, page = 0, size = 0) => {
            let deffered = this.$q.defer();
            !size && (size = this.viewPortSize*this.gridItemSize);
            let folderType = this.folders[this.module].find((f) => f.id == folderId).folderType;
            let filter = {
                documentTypes: [this.getDocumentType(this.module)],
                addComments: false,
                folderId,
                folderType
            };
            if (!!subjectId) {
                filter['subjectId'] = subjectId;
            }
            this.$_feed.getPaginatedFolderFeeds(page, size, filter, sortProp, folderId).then( data => {
                deffered.resolve(data);
            })
            return deffered.promise;
        };

        fetchFolderContents = (folderId : number, subjectId : number, sortBy : {}) => {
            let deferred = this.$q.defer();
            let setFolder = () => {
                this.fetchChildFolders(folderId, sortBy, subjectId).then(() => {
                    this.fetchChildDocs(folderId, subjectId).then(({docs, totalElements}) => {
                        let folder = angular.copy(this.folders[this.module].find((f) => f.id == folderId));
                        folder.documents = docs;
                        folder.childDocCount = totalElements;
                        //Add shortcut for subject
                        if (this.module == FOLDER_MODULES.DOCUMENT && this.$_cache.getUser().organizationId > 0 && !!subjectId && folder.folderType != FolderTypeCodes.ENTERPRISE_TEAMS && folder.subjectId != subjectId) {
                            this.fetchSubjectFolder(subjectId).then((subjFldr) => {
                                if(!!subjFldr) {
                                    let sf : any = angular.copy(subjFldr);
                                    sf.folderType = FolderTypeCodes.SHORT_CUT;
                                    sf.allowedOperation = 0;
                                    sf.type = this.ItemTypeEnum.FOLDER;
                                    folder.teamShortcut = sf;
                                    folder.childCount++;
                                }
                                deferred.resolve(folder);
                            });
                        } else {
                            deferred.resolve(folder);
                        }
                    });
                });
            }
            let folderInd = this.folders[this.module].findIndex((f) => f.id == folderId);
            if(folderInd == -1){
                this.fetchFolderHierarchy(folderId,this.module,subjectId).then((fldrs : []) => {
                    fldrs.forEach((f:any) => {
                        f.type = this.ItemTypeEnum.FOLDER;
                        if(!this.folders[this.module].find(fldr => fldr.id == f.id)){
                            this.folders[this.module].push(f);
                        }
                    });
                    setFolder();
                });
            } else {
                setFolder();
            }
            return deferred.promise;
        }

        updateChildren = (folderId) => {
            let folder = this.fetchFolderById(folderId);
            if(!!folder){
                folder['childCount']++;
                folder['reloadChildren'] = true;
            }
        }

        changeDocumentParent = (folder) => {
            this.$_caching.addOrUpdateDocuments([folder]);
        }

        changeFolderParent = (oldPrntId : number, newPrntId : number) => {
            this.resetChildren({id: oldPrntId});
            let folder = this.fetchFolderById(newPrntId);
            if(!!folder){
                folder['childCount']++;
                folder['reloadChildren'] = true;
            }
        }

        getAllChildFolders = (folderId : number, subId : number) => {
            let deferred = this.$q.defer();
            let params = {
                documentType: this.getDocumentType(this.module),
                pageSize: 9999,
                lastId: 0
            };
            if(!!subId){
                params['subjectId'] = subId;
            }
            this.fetchFolderWithSubject(folderId, params).then((data) => {
                deferred.resolve(data['folders']);
            });
            return deferred.promise;
        }

        checkFolderContents = (folderId : string) => {
            let deferred = this.$q.defer();
            let hasContent = false;
            let docs = this.$_caching.getCachedFolderFeedsById(folderId);
            let folder = this.fetchFolderById(folderId);
            if ((!!folder && folder['childCount'] > 0) || docs.length > 0) {
                hasContent = true;
            }
            deferred.resolve(hasContent);
            return deferred.promise;
        }

        createExtBreadcrumb = (fldrs) => {
            let breadcrumb = [];
            fldrs.reverse().forEach((fldr) =>{
                breadcrumb.push({
                    id: fldr.id,
                    name: fldr.name,
                    type: fldr.folderType,
                    allowedOperation : fldr.allowedOperation
                });
            });
            return breadcrumb;
        }

        getBrdcrmbFromFolderId = (folderId, module): ng.IPromise<any> => {
            var deferred = this.$q.defer();
            if(!folderId){
                this.fetchRootFolderByType(module).then((root) => {
                    deferred.resolve(this.createExtBreadcrumb([root]));
                })
            } else {
                this.fetchFolderHierarchy(folderId,module).then((fldrs) => {
                    deferred.resolve(this.createExtBreadcrumb(fldrs));
                })
            }
            return deferred.promise;
        }

        getBrdcrmbFromSubjectId = (subjectId,module) => {
            var deferred = this.$q.defer();
            this.fetchFolderHierarchy(0,module,subjectId).then((subFldrs) => {
                deferred.resolve(this.createExtBreadcrumb(subFldrs));
            });
            return deferred.promise;
        }

        createBreadcrumb = (folderId, type: string) => {
            let deferred = this.$q.defer();
            if (!this.folders || !this.folders[type]) {
                this.init(type).then(() => {
                    this.getBreadcrumb(folderId, type).then((b) => {
                        deferred.resolve(b);
                    });
                });
            } else {
                this.getBreadcrumb(folderId, type).then((b) => {
                    deferred.resolve(b);
                });
            }

            return deferred.promise;
        }

        getBreadcrumb = (folderId, type: string) => {
            let deferred = this.$q.defer();
            let folder : DocumentFolder;
            if (!!folderId) {
                folder = this.folders[type].find(f => f.id == folderId);
            } else {
                folder = this.folders[type].filter((f) => { return f.parentId == 0 })[0];
                folderId = folder.id;
            }
            let breadcrumb = [
                {
                    id: folder.id,
                    name: folder.name
                }
            ];

            while (folder.parentId != 0) {
                folder = this.folders[type].find(f => f.id == folder.parentId);
                let bc = {
                    id: folder.id,
                    name: folder.name
                };
                breadcrumb.unshift(bc);
            }
            deferred.resolve(breadcrumb);
            return deferred.promise;
        }

         getFolderHierarchy= (folderId : number | String)=> {
             let deferred = this.$q.defer();
            let folder = this.folderFilterList.find(folder => folder.id === folderId);

            if (!folder) {
                return null; // Folder not found
            }

            const hierarchy = [folder.name];
            if(folder.parentIds && folder.parentIds.length > 0) {
               folder.parentIds.forEach((parentId : number) =>{
                   let fld = this.folderFilterList.find(f => f.id === parentId);
                   if (!!fld) {
                       hierarchy.unshift(fld.name);
                   }
               })
            }
             if (hierarchy.length > 1) {
                 hierarchy.shift();
             }
             deferred.resolve(hierarchy);
            return deferred.promise;
        }

        updateFolderUpdationDate = (folderId : number, date : Date, type: string) => {
            if (!!this.folders && !!this.folders[type]) {
                var folder = this.folders[type].find(f => f.id == folderId);
                if (folder) {
                    folder.updatedAt = date;
                }
                let children = _.remove(this.folders[type], f => f.parentId == folder.parentId);
                if(children.length > 0) {
                    children = this.$filter('orderBy')(children, ['folderType == "ENTERPRISE"', 'folderType == "SYSTEM"', this.folderSort['sortBy']], this.folderSort['sortOrder']);
                    this.folders[type] = [...this.folders[type], ...children];
                }
            }
        }

        deleteFolder = (folderId : number) => {
            var ind = this.folders[this.module].findIndex(function (f) { return f.id == folderId; });
            let deletedFldr = this.folders[this.module].splice(ind, 1);
            let prntFldr = this.fetchFolderById(deletedFldr[0].parentId);
            prntFldr['childCount']--;
        }

        folderOperation: ($event: any, operation: string, item: any) =>{
            //this is overridden from mainBoard.directive
        }

        organize = (currentFolderId : number) => {
            this.PaymentService.checkLimitAndProceed("document", () => {
                this.$state.go('organize', {ref: 'docs', folderId: currentFolderId});
            });

        }
        connect = (currentFolderId : number) => {
            this.PaymentService.checkLimitAndProceed("discussion", () => {
                this.$state.go('connect', {ref: 'discs', folderId: currentFolderId});
            });
        }

        static $inject = ['$q', 'CacheService', 'CachingService', 'UtilityService', 'ApiAdapterService', '$rootScope', '$timeout',
            'CommonService','PopUpService', 'PaymentService','$state', '$filter', 'FeedService',"SubjectService", "PermissionService"];

        constructor(private $q : ng.IQService,
                    private $_cache: CacheService,
                    private $_caching: ICachingService,
                    private $_util: IUtilityService,
                    private $_api: JavaApiAdapterService,
                    private $rootScope : IAppRootScopeService,
                    private $timeout: ng.ITimeoutService,
                    private $_comService: CommonService,
                    private PopUpService : PopUpService,
                    private PaymentService : PaymentService,
                    private $state : ng.ui.IStateService,
                    private $filter : ng.IFilterService,
                    private $_feed: IFeedService,
                    private $sub : SubjectService,
                    private PermissionService : PermissionService
        ) {
        }
    }
    angular.module('eCareVault.common.itemBoard')
        .service('DocumentFolderService', DocumentFolderService);

